import './ccf-draggable-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfDraggableIconProps extends SvgIconProps  {}
/**
 * component used to display draggable icon
 * @param props - CcfDraggableIconProps
 * @example - <CcfDraggableIcon />
 * @returns SVG of draggable icon
 */
export function CcfDraggableIcon(props: CcfDraggableIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24"  {...props}>
      <g id="ic_handle" clipPath="url(#clip-ic_handle)">
        <g id="Group_119454" data-name="Group 119454" transform="translate(32.904 32.141) rotate(180)">
          <rect id="Rectangle_22331" data-name="Rectangle 22331" width="40" height="40" transform="translate(0.904 0.141)" fill="#fff" opacity="0"/>
          <rect id="Rectangle_80630" data-name="Rectangle 80630" width="2" height="2" transform="translate(23.904 27.141) rotate(-180)" fill="#708590"/>
          <rect id="Rectangle_80631" data-name="Rectangle 80631" width="2" height="2" transform="translate(19.904 27.141) rotate(-180)" fill="#708590"/>
          <rect id="Rectangle_80632" data-name="Rectangle 80632" width="2" height="2" transform="translate(23.904 23.141) rotate(-180)" fill="#708590"/>
          <rect id="Rectangle_80633" data-name="Rectangle 80633" width="2" height="2" transform="translate(19.904 23.141) rotate(-180)" fill="#708590"/>
          <rect id="Rectangle_80634" data-name="Rectangle 80634" width="2" height="2" transform="translate(23.904 19.141) rotate(-180)" fill="#708590"/>
          <rect id="Rectangle_80635" data-name="Rectangle 80635" width="2" height="2" transform="translate(19.904 19.141) rotate(-180)" fill="#708590"/>
          <rect id="Rectangle_80636" data-name="Rectangle 80636" width="2" height="2" transform="translate(23.904 15.141) rotate(-180)" fill="#708590"/>
          <rect id="Rectangle_80637" data-name="Rectangle 80637" width="2" height="2" transform="translate(19.904 15.141) rotate(-180)" fill="#708590"/>
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfDraggableIcon;
